import { AppOrigin } from "@accurx/message-component";
import { PatientDemographics } from "@accurx/native";
import { PatientSearchResult } from "@accurx/patient";

import { RouterState } from "./Routes.types";

export const createRouterState = ({
    appOrigin,
    patient,
    demographics,
}: {
    patient: PatientSearchResult;
    /** In case we're messaging a new patient from
     * integrated system we need to save demographics to the
     * database, so we need to keep hold of them in intact form
     * */
    demographics: PatientDemographics | null;
    appOrigin?: keyof typeof AppOrigin;
}): RouterState => {
    return {
        appOrigin,
        searchedPatient: patient,
        demographics: demographics ?? undefined,
    };
};
